export default "__VITE_ASSET__BUffttRL__"